const lockScroll = () => {
  const body = document.querySelector('body');
  body.style.overflow = 'hidden';
};

const unlockScroll = () => {
  const body = document.querySelector('body');
  body.style.overflow = 'auto';
};

function getOrdinalSuffix(day) {
  const remainder10 = day % 10;
  const remainder100 = day % 100;

  // Check special cases for teens
  if (remainder100 >= 11 && remainder100 <= 13) {
    return day + 'th';
  }

  // Check last digit
  switch (remainder10) {
    case 1:
      return day + 'st';
    case 2:
      return day + 'nd';
    case 3:
      return day + 'rd';
    default:
      return day + 'th';
  }
}

export { lockScroll, unlockScroll, getOrdinalSuffix };
